


























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { SurveyItem } from "@/models/SurveyItem";
import { ValidationProvider } from "vee-validate";
import { FontSize } from "@/views/Survey.vue";

@Component({
  components: {
    ValidationProvider
  }
})
export default class SelectItem extends Vue {
  @Prop({ type: Object })
  item!: SurveyItem;

  @Prop({ type: String, default: "" })
  value!: string;

  @Prop({ type: Number, default: 0 })
  langValue!: number;

  @Prop({ type: Number, default: 0 })
  fontSize!: FontSize;

  localValue!: string;

  COUNTRY_LIST = [
    { label: "Afghanistan", value: "AFG" },
    { label: "Albania", value: "ALB" },
    { label: "Algeria", value: "ALG" },
    { label: "Andorra", value: "AND" },
    { label: "Angola", value: "ANG" },
    { label: "Antigua and Barbuda", value: "ANT" },
    { label: "Argentina", value: "ARG" },
    { label: "Armenia", value: "ARM" },
    { label: "Aruba", value: "ARU" },
    { label: "American Samoa", value: "ASA" },
    { label: "Australia", value: "AUS" },
    { label: "Austria", value: "AUT" },
    { label: "Azerbaijan", value: "AZE" },
    { label: "Bahamas", value: "BAH" },
    { label: "Bangladesh", value: "BAN" },
    { label: "Barbados", value: "BAR" },
    { label: "Burundi", value: "BDI" },
    { label: "Belgium", value: "BEL" },
    { label: "Benin", value: "BEN" },
    { label: "Bermuda", value: "BER" },
    { label: "Bhutan", value: "BHU" },
    { label: "Bosnia and Herzegovina", value: "BIH" },
    { label: "Belize", value: "BIZ" },
    { label: "Belarus", value: "BLR" },
    { label: "Bolivia", value: "BOL" },
    { label: "Botswana", value: "BOT" },
    { label: "Brazil", value: "BRA" },
    { label: "Bahrain", value: "BRN" },
    { label: "Brunei Darussalam", value: "BRU" },
    { label: "Bulgaria", value: "BUL" },
    { label: "Burkina Faso", value: "BUR" },
    { label: "Central African Republic", value: "CAF" },
    { label: "Cambodia", value: "CAM" },
    { label: "Canada", value: "CAN" },
    { label: "Cayman Islands", value: "CAY" },
    { label: "Congo", value: "CGO" },
    { label: "Chad", value: "CHA" },
    { label: "Chile", value: "CHI" },
    { label: "People's Republic of China", value: "CHN" },
    { label: "Côte d'Ivoire", value: "CIV" },
    { label: "Cameroon", value: "CMR" },
    { label: "Democratic Republic of the Congo", value: "COD" },
    { label: "Cook Islands", value: "COK" },
    { label: "Colombia", value: "COL" },
    { label: "Comoros", value: "COM" },
    { label: "Cape Verde", value: "CPV" },
    { label: "Costa Rica", value: "CRC" },
    { label: "Croatia", value: "CRO" },
    { label: "Cuba", value: "CUB" },
    { label: "Cyprus", value: "CYP" },
    { label: "Czech Republic", value: "CZE" },
    { label: "Denmark", value: "DEN" },
    { label: "Djibouti", value: "DJI" },
    { label: "Dominique", value: "DMA" },
    { label: "Dominican Republic", value: "DOM" },
    { label: "Ecuador", value: "ECU" },
    { label: "Egypt", value: "EGY" },
    { label: "Eritrea", value: "ERI" },
    { label: "El Salvador", value: "ESA" },
    { label: "Spain", value: "ESP" },
    { label: "Estonia", value: "EST" },
    { label: "Ethiopia", value: "ETH" },
    { label: "Fiji", value: "FIJ" },
    { label: "Finland", value: "FIN" },
    { label: "France", value: "FRA" },
    { label: "Federated States of Micronesia", value: "FSM" },
    { label: "Gabon", value: "GAB" },
    { label: "Gambia", value: "GAM" },
    { label: "Great Britain", value: "GBR" },
    { label: "Guinea-Bissau", value: "GBS" },
    { label: "Georgia", value: "GEO" },
    { label: "Equatorial Guinea", value: "GEQ" },
    { label: "Germany", value: "GER" },
    { label: "Ghana", value: "GHA" },
    { label: "Greece", value: "GRE" },
    { label: "Grenada", value: "GRN" },
    { label: "Guatemala", value: "GUA" },
    { label: "Guinea", value: "GUI" },
    { label: "Guam", value: "GUM" },
    { label: "Guyana", value: "GUY" },
    { label: "Haiti", value: "HAI" },
    { label: "Hong Kong, China", value: "HKG" },
    { label: "Honduras", value: "HON" },
    { label: "Hungary", value: "HUN" },
    { label: "Indonesia", value: "INA" },
    { label: "India", value: "IND" },
    { label: "Islamic Republic of Iran", value: "IRI" },
    { label: "Ireland", value: "IRL" },
    { label: "Iraq", value: "IRQ" },
    { label: "Iceland", value: "ISL" },
    { label: "Israel", value: "ISR" },
    { label: "Virgin Islands, US", value: "ISV" },
    { label: "Italy", value: "ITA" },
    { label: "Virgin Islands, British", value: "IVB" },
    { label: "Jamaica", value: "JAM" },
    { label: "Jordan", value: "JOR" },
    { label: "Japan", value: "JPN" },
    { label: "Kazakhstan", value: "KAZ" },
    { label: "Kenya", value: "KEN" },
    { label: "Kyrgyzstan", value: "KGZ" },
    { label: "Kiribati", value: "KIR" },
    { label: "Republic of Korea", value: "KOR" },
    { label: "Kosovo", value: "KOS" },
    { label: "Saudi Arabia", value: "KSA" },
    { label: "Kuwait", value: "KUW" },
    { label: "Lao People's Democratic Republic", value: "LAO" },
    { label: "Latvia", value: "LAT" },
    { label: "Libya", value: "LBA" },
    { label: "Lebanon", value: "LBN" },
    { label: "Liberia", value: "LBR" },
    { label: "Saint Lucia", value: "LCA" },
    { label: "Lesotho", value: "LES" },
    { label: "Liechtenstein", value: "LIE" },
    { label: "Lithuania", value: "LTU" },
    { label: "Luxembourg", value: "LUX" },
    { label: "Madagascar", value: "MAD" },
    { label: "Morocco", value: "MAR" },
    { label: "Malaysia", value: "MAS" },
    { label: "Malawi", value: "MAW" },
    { label: "Republic of Moldova", value: "MDA" },
    { label: "Maldives", value: "MDV" },
    { label: "Mexico", value: "MEX" },
    { label: "Mongolia", value: "MGL" },
    { label: "Marshall Islands", value: "MHL" },
    { label: "North Macedonia", value: "MKD" },
    { label: "Mali", value: "MLI" },
    { label: "Malta", value: "MLT" },
    { label: "Montenegro", value: "MNE" },
    { label: "Monaco", value: "MON" },
    { label: "Mozambique", value: "MOZ" },
    { label: "Mauritius", value: "MRI" },
    { label: "Mauritania", value: "MTN" },
    { label: "Myanmar", value: "MYA" },
    { label: "Namibia", value: "NAM" },
    { label: "Nicaragua", value: "NCA" },
    { label: "Netherlands", value: "NED" },
    { label: "Nepal", value: "NEP" },
    { label: "Nigeria", value: "NGR" },
    { label: "Niger", value: "NIG" },
    { label: "Norway", value: "NOR" },
    { label: "Nauru", value: "NRU" },
    { label: "New Zealand", value: "NZL" },
    { label: "Oman", value: "OMA" },
    { label: "Pakistan", value: "PAK" },
    { label: "Panama", value: "PAN" },
    { label: "Paraguay", value: "PAR" },
    { label: "Peru", value: "PER" },
    { label: "Philippines", value: "PHI" },
    { label: "Palestine", value: "PLE" },
    { label: "Palau", value: "PLW" },
    { label: "Papua New Guinea", value: "PNG" },
    { label: "Poland", value: "POL" },
    { label: "Portugal", value: "POR" },
    { label: "Democratic People's Republic of Korea", value: "PRK" },
    { label: "Puerto Rico", value: "PUR" },
    { label: "Qatar", value: "QAT" },
    { label: "Romania", value: "ROU" },
    { label: "South Africa", value: "RSA" },
    { label: "Russian Federation", value: "RUS" },
    { label: "Rwanda", value: "RWA" },
    { label: "Samoa (until 1996 Western Samoa)", value: "SAM" },
    { label: "Senegal", value: "SEN" },
    { label: "Seychelles", value: "SEY" },
    { label: "Singapore", value: "SGP" },
    { label: "Saint Kitts and Nevis", value: "SKN" },
    { label: "Sierra Leone", value: "SLE" },
    { label: "Slovenia", value: "SLO" },
    { label: "San Marino", value: "SMR" },
    { label: "Solomon Islands", value: "SOL" },
    { label: "Somalia", value: "SOM" },
    { label: "Serbia", value: "SRB" },
    { label: "Sri Lanka", value: "SRI" },
    { label: "South Sudan", value: "SSD" },
    { label: "Sao Tome and Principe", value: "STP" },
    { label: "Sudan", value: "SUD" },
    { label: "Switzerland", value: "SUI" },
    { label: "Suriname", value: "SUR" },
    { label: "Slovakia", value: "SVK" },
    { label: "Sweden", value: "SWE" },
    { label: "Eswatini", value: "SWZ" },
    { label: "Syrian Arab Republic", value: "SYR" },
    { label: "United Republic of Tanzania", value: "TAN" },
    { label: "Tonga", value: "TGA" },
    { label: "Thailand", value: "THA" },
    { label: "Tajikistan", value: "TJK" },
    { label: "Turkmenistan", value: "TKM" },
    { label: "Timor-Leste", value: "TLS" },
    { label: "Togo", value: "TOG" },
    { label: "Chinese Taipei", value: "TPE" },
    { label: "Trinidad and Tobago", value: "TTO" },
    { label: "Tunisia", value: "TUN" },
    { label: "Turkey", value: "TUR" },
    { label: "Tuvalu", value: "TUV" },
    { label: "United Arab Emirates", value: "UAE" },
    { label: "Uganda", value: "UGA" },
    { label: "Ukraine", value: "UKR" },
    { label: "Uruguay", value: "URU" },
    { label: "United States of America", value: "USA" },
    { label: "Uzbekistan", value: "UZB" },
    { label: "Vanuatu", value: "VAN" },
    { label: "Venezuela", value: "VEN" },
    { label: "Vietnam", value: "VIE" },
    { label: "St Vincent and the Grenadines", value: "VIN" },
    { label: "Yemen", value: "YEM" },
    { label: "Zambia", value: "ZAM" },
    { label: "Zimbabwe", value: "ZIM" }
  ];

  created() {
    if (this.value == "") {
      this.localValue = localStorage.getItem(this.item.id) ?? "";
      this.$emit("input", this.localValue);
    } else {
      this.localValue = this.value;
    }
  }

  changeSelectListFontSize(size: FontSize) {
    let targetClass = "";
    switch (size) {
      case FontSize.small:
        targetClass = "list-item__font_size_small";
        break;
      case FontSize.medium:
        targetClass = "list-item__font_size_medium";
        break;
      case FontSize.large:
        targetClass = "list-item__font_size_large";
        break;
    }
    const elements = document.querySelectorAll(
      ".v-list-item__title, .select-list__font_size_small, .select-list__font_size_medium, .select-list__font_size_large"
    );
    elements.forEach(elem => {
      elem.classList.forEach(c => elem.classList.remove(c.toString()));
      elem.classList.add(targetClass);
    });
  }

  @Watch("fontSize")
  onFontSizeChanged(newSize: FontSize) {
    this.changeSelectListFontSize(newSize);
  }

  updateValue(value: string) {
    localStorage.setItem(this.item.id, value ?? "");
    this.localValue = value;
    this.$emit("input", value);
  }
}
